import type { ReactNode } from 'react';
import { useTooltipsEnabled } from './tooltip-preference';

/** Keep SVG help as an accessible description when hover hints are disabled. */
export function TooltipTitle({ children }: { children: ReactNode }) {
  return useTooltipsEnabled() ? <title>{children}</title> : <desc>{children}</desc>;
}
